module.exports = __webpack_public_path__ + "img/title-4.151b9dff.png";